// function to strip html tags from a string
//
// Usage:
// const str = '<p>hello world</p>'
// const stripped = stripHtml(str)
//       ^ 'hello world'
export function stripHtml(html: string) {
  return html.replace(/<[^>]*>?/gm, '')
}
